import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import SubMenu from '../layouts/SubMenu'
import { isCemFeatureEnabled } from '../../rsmCoreComponents/utils/featureFlagUtils'
import { CEM_FEATURE_QUESTIONNAIRE_ASSIGN } from '../../utils/constants/constants'
import { getCemFeatures } from '../../store/userInfo/userInfoSlice'
import RouterNavListItem from '../Navigation/NavListItem/RouterNavListItem'

type QuestionnaireMenuProps = {
  currentItem?: string
}

const QuestionnaireMenu = ({ currentItem = '' }: QuestionnaireMenuProps) => {
  const { t } = useTranslation()
  const cemFeatures = useSelector(getCemFeatures)
  const isAssignor = useMemo(
    () =>
      isCemFeatureEnabled(CEM_FEATURE_QUESTIONNAIRE_ASSIGN, cemFeatures, 'any'),
    [cemFeatures],
  )

  return (
    <SubMenu currentItem={currentItem} title={t('Navigation.Questionnaire.My')}>
      {isAssignor && (
        <RouterNavListItem
          to="/questionnaires/queue"
          value="queue"
          testId="Lnk_Navigation_Questionnaire_Queue">
          {t('Navigation.Questionnaire.SearchAssign')}
        </RouterNavListItem>
      )}
    </SubMenu>
  )
}

export default QuestionnaireMenu
